import { render, staticRenderFns } from "./ForumList.vue?vue&type=template&id=dd018d2e&scoped=true&"
import script from "./ForumList.vue?vue&type=script&lang=js&"
export * from "./ForumList.vue?vue&type=script&lang=js&"
import style0 from "./ForumList.vue?vue&type=style&index=0&id=dd018d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd018d2e",
  null
  
)

export default component.exports